import {actions} from 'react-fields'

class CountriesAPI {

    static getCollection(options) {
        let url = '/api/countries';
        if (options) {
            url = `${url}?${actions.paramsToURI(options)}`
        }

        return fetch(actions.getData(url))
            .then(actions.status)
            .then(actions.json)
    }


}

export default CountriesAPI;